import { useSyncExternalStore } from 'react';

// Sidebar'ning faqat vizual holati: yig'ilganmi (desktop) va mobil panel ochiqmi.
// Header (menyu tugmasi) va AppSidebar o'rtasida App.jsx'ga state qo'shmasdan ulashiladi.
const COLLAPSED_KEY = 'ui_sidebar_collapsed';

function readCollapsed() {
  try {
    return window.localStorage.getItem(COLLAPSED_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

let state = { collapsed: readCollapsed(), mobileOpen: false };
const listeners = new Set();

function setState(patch) {
  state = { ...state, ...patch };
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const getSnapshot = () => state;

export const sidebarActions = {
  toggleCollapsed() {
    const collapsed = !state.collapsed;
    try {
      window.localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch (error) {
      // localStorage mavjud bo'lmasa (private rejim) holat faqat shu sessiyada saqlanadi.
    }
    setState({ collapsed });
  },
  openMobile() {
    if (!state.mobileOpen) setState({ mobileOpen: true });
  },
  closeMobile() {
    if (state.mobileOpen) setState({ mobileOpen: false });
  },
};

export function useSidebarState() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
